import React, { useEffect } from 'react';
import { useT } from '../context/AppContext';
import './Notification.css';

const Notification = ({ type = 'success', message, onClose }) => {
  const tr = useT();

  useEffect(() => {
    const timer = setTimeout(onClose, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const icons = { success: 'fa-check-circle', error: 'fa-times-circle', warning: 'fa-exclamation-triangle', info: 'fa-info-circle' };
  const titles = { success: tr('succes'), error: tr('erreur'), warning: tr('attention'), info: tr('information') };

  return (
    <div className={`notification notification-${type} show`}>
      <div className="notification-icon">
        <i className={`fas ${icons[type] || 'fa-info-circle'}`}></i>
      </div>
      <div className="notification-content">
        <div className="notification-title">{titles[type] || tr('information')}</div>
        <p className="notification-message">{message}</p>
      </div>
      <button className="notification-close" onClick={onClose} aria-label="Fermer">
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
};

export default Notification;